export default __webpack_public_path__ + "assets/Ominvore Test With Plume.855a56f3.png";